import * as ko from "knockout";
import entityBase from "entityBase";
import * as _ from "lodash";
import labels from "app/labels";

export class exception_type extends entityBase {
  exception_type: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  item_style_id: KnockoutObservable<string>;
  available: KnockoutObservable<string>;

  translatedExceptionName: KnockoutComputed<string>;

  constructor(item: any) {
    super();
    this.exception_type = ko.observable(item.exception_type);
    this.description = ko.observable(item.description);
    this.item_style_id = ko.observable(item.item_style_id);
    this.available = ko.observable(item.available);

    this.translatedExceptionName = ko.pureComputed(() => {
      return labels.descr(`cc_P_${_.upperCase(this.exception_type())}`);
    });
  }
}
